/**
 * Registers the usage screen at `/usage`, order 40.
 *
 * `UsageGroupBy`/`SpendQuery` are re-exported here, not redeclared: `../api/
 * queries` already exports a `SpendQuery`, tightened to
 * `groupBy: UsageGroupBy` there, so this file reuses it rather than adding a
 * second, looser type of the same name in a second file.
 */

import { ChartColumn } from 'lucide-react';
import { createElement } from 'react';

import { defineCatalogue } from '../../i18n';
import type { OpsRouteBundle } from '../routes/contract';
import { OpsShell } from '../shell/OpsShell';
import { Usage } from './Usage';

export type { SpendQuery, UsageGroupBy } from '../api/queries';

// Figma 153:342: the sidebar entry reads "Uso e margem", not the bare "Uso".
const catalogue = defineCatalogue({ navLabel: 'Uso e margem' }, { navLabel: 'Usage and margin' });

export const bundle: OpsRouteBundle = {
  order: 40,
  routes: [
    { path: '/usage', element: createElement(OpsShell, null, createElement(Usage)), kind: 'data' },
  ],
  nav: [{ path: '/usage', label: () => catalogue.t('navLabel'), icon: ChartColumn, kind: 'data' }],
};
